import png1 from "./1.jpg";
import png2 from "./2.jpg";
import png3 from "./3.jpg";
import png4 from "./4.jpg";
import png5 from "./5.jpg";
export const gdyh = [
  {
    name: "查找流水",
    msgList: [
      {
        msg: "登录光大银行APP->顶部搜索【交易明细】->【电子证明】->点击【申请】",
      },
      { imgs: [png1, png2, png3, png4] },
    ],
  },
  {
    name: "发送账单",
    msgList: [
      { msg: "时间选择近一年的时间，【先导出前半年，再导出后半年】" },
      { imgs: [png5] },
    ],
  },
  {
    name: "注意事项",
    msgList: [{ msg: "先导出前半年，再导出后半年；返回引导页面，在底部点击【上传账单】即可" }],
  },
];
